import { actions } from '../actions/monitor';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.requestSuccess:
      return action.payload;
    case actions.paginateSuccess:
      return [
        ...state,
        ...action.payload
      ];
    default:
      return state;
  }
};
